/**
 * filterUsers :: (Object, Boolean) -> [Object]
 * filter users according to 'isDeleted' & 'isDefault' status
 */
export const filterUsers = (users, isDeleted) =>
  Object.values(users).filter(user =>
    !!user.isDeleted === !!isDeleted && !user.isDefault);



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/utils.js